(function () {
  const Blog = {
    init: function () {
      this.eventListenersInit();
    },

    eventListenersInit: function() {
      const categoryLinks = document.querySelectorAll('.filter-category-link');
      categoryLinks.forEach(categoryLink => {
        categoryLink.addEventListener(
          'click',
          (event) => {
            event.preventDefault();
            const targetBlogsContainerElement = document.getElementById(categoryLink.dataset.targetId);
            window.scroll({
              top: targetBlogsContainerElement.offsetTop - 100,
              left: 0,
              behavior: 'smooth'
            });
          }
        );
      });
    }
  };

  window.addEventListener('load', (event) => {
    Blog.init();
  });

})();
